// extracted by mini-css-extract-plugin
module.exports = {"nameAndPhoneList":"ContactInfo_nameAndPhoneList__TwZmb","label":"ContactInfo_label__Vvf3Y","editButton":"ContactInfo_editButton__C7H8k"};